<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause" id="clause" ref="scrollDom">
        <div>
          <p style="line-height:22pt; margin:0pt; orphans:0; text-align:center; widows:0">
            <span style="font-family:宋体; font-size:22pt; font-weight:bold">个人</span>
            <span style="font-family:宋体; font-size:22pt; font-weight:bold">信息</span>
            <span style="font-family:宋体; font-size:22pt; font-weight:bold">处理</span>
            <span style="font-family:宋体; font-size:22pt; font-weight:bold">授权书</span>
          </p>
          <p style="line-height:22pt; margin:0pt; orphans:0; text-align:center; widows:0">
            <span style="font-family:宋体; font-size:22pt; font-weight:bold">&nbsp;</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">尊敬的客户：</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">为了维护您的权益，请在签署本授权书前，仔细阅读本授权书各条款（特别</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">关注字体加黑、加粗表述</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">），关注您对本行的授权内容</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">以及您的权利、义务和责任</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如您对本授权书的内容有任何疑问</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">意见或建议</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，您可致电</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">客户服务电话95396</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">进行咨询，或者通过贷款人和/或贷款人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">合作机构的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">线上服务平台、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">线上客服</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">等进行咨询了解</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">查询、获知您行使个人信息主体相关权利的方式和程序。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">一旦您通过点击或其他方式确认本授权书，即意味着您</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">已知晓、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">理解本授权书中的全部内容（包括对有关权利义务和/或责任限制、免除条款的法律含义有充分的理解），同意按照本授权书条款处理您的相关信息。如涉及合作金融机构咨询与投诉事项，您也可以通过上述方式联系亿联银行协助转办。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; widows:0">
            <span style="font-family:宋体; font-size:11pt; text-decoration:underline">吉林</span>
            <span style="font-family:宋体; font-size:11pt; text-decoration:underline">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt; text-decoration:underline">股份有限公司</span>
            <span style="font-family:宋体; font-size:11pt">（以下简称：被授权人）:</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">本人</span><span style="font-family:宋体; font-size:11pt">（</span>
            <span style="font-family:宋体; font-size:11pt">即授权人</span><span style="font-family:宋体; font-size:11pt">）</span>
            <span style="font-family:宋体; font-size:11pt">已仔细阅读本授权书的全部内容，</span>
            <span style="font-family:宋体; font-size:11pt">充分理解并同意，本贷款服务是被授权人为本人提供的个人贷款服务，为客观、准确地评估本人的信用等级和授信额度，并为本人提供优质的服务，就使用本人的相关必要信息，本人同意并授权如下：</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">一、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人同意并授权</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">处理（包括但不限于</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">收集、存储、使用</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">加工、传输、提供、公开、删除等</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">）</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如下个人信息：</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">1、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">个人基本信息：包括姓名、性别、国籍、职业、工作单位、联系地址、联系方式、个人电子邮件；</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">2、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">个人身份信息：包括</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">身份证、居住证</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">证件</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">类型</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">及号码、有效</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">期限</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">公安身份核验信息、学历学籍信息</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">3</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、个人财产信息：银行账户信息</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">（</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">含开户人名称和开户行名称、账号</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">）</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、鉴别信息（口令）、资产信息、房产信息、收入状况、信贷记录、征信信息、交易和消费记录、流水记录、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">生产经营、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">税务信息、社保账户信息及公积金信息。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">4</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、个人生物识别信息：指纹、面部识别特征。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">5、网络身份标识信息：个人信息主体账号、IP地址、个人数字证书。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">6</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、个人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">常用设备信息等</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">其他信息：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">运营商信息、手机号码归属、工商信息、司法信息、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">精准定位信息、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">唯一</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">设备识别码、设备</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">MAC</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">地址、社交平台账号信息、常用设备信息、浏览器环境信息、音视频双录信息（包含电核录音、视频连线、视频核验等）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">7、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">基于前述信息对个人信用状况形成的分析、评价类信息</span>
            <span style="font-family:宋体; font-size:11pt">。</span>
          </p>
          <p style="margin:0pt 0pt 10pt; text-indent:22pt">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">8、其他合法存有本人信息的第三方所存的能够评估和反映本人信用和风险状况的信息。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">二、本人同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">基于提供贷款服务的需求，将个人信息用于贷款服务相关的身份识别、资质审查、风险评估、</span>
            <span style="font-family:宋体; font-size:11pt">风险管理、</span>
            <span style="font-family:宋体; font-size:11pt">贷前调查、审查审批、合同签署、放款审核、额度管理、风险监测、担保办理、客户服务、权益服务、贷后管理（含催收、逾期资产处置、诉讼仲裁）、贷后服务、资产转让、债权转让、客户服务（含投诉处理）、数据研究分析等用途</span>
            <span style="font-family:宋体; font-size:11pt">，</span>
            <span style="font-family:宋体; font-size:11pt">以及在被授权人监管机构要求的信用监控、授权人申请征信异议处理、依法或依有权部门要求的其他工作，或其他经本人同意的合法用途</span>
            <span style="font-family:宋体; font-size:11pt">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">1、本人同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">：被授权人</span>
            <span style="font-family:宋体; font-size:11pt">基于处理目的收集、存储、使用、加工本人在使用信贷服务过程中主动提供或因此产生的个人信息。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">2、</span><span style="font-family:宋体; font-size:11pt">本人</span>
            <span style="font-family:宋体; font-size:11pt">同意并授权</span><span style="font-family:宋体; font-size:11pt">：被授权人</span>
            <span style="font-family:宋体; font-size:11pt">基于处理目的向金融信用信息基础数据库、</span>
            <span style="font-family:宋体; font-size:11pt">国务院征信业监督管理部门批准设立的征信机构【包括但不限于</span>
            <span style="font-family:宋体; font-size:11pt">百行征信有限公司、朴道征信有限公司</span>
            <span style="font-family:宋体; font-size:11pt">】</span><span style="font-family:宋体; font-size:11pt">、</span>
            <span style="font-family:宋体; font-size:11pt">政府部门或由政府部门授权的其他第三方机构以及其他被授权人合作机构【包括但不限于全国公民身份证号码查询服务中心（公安部公民身份信息数据库）、教育部学生服务与素质发展中心（即中国高等教育学生信息网）、中国银联股份有限公司、百融云创科技股份有限公司、北京中盾安信科技发展有限公司、中国司法大数据研究院有限公司、金保信社保卡科技有限公司、中国联合网络通讯有限公司及其分公司或全资子公司、中国移动通信集团有限公司及其分公司或其他代理通讯运营商业务的机构】、</span>
            <span style="font-family:宋体; font-size:11pt">社会保障管理机构、住房公积金管理机构、银行卡清算机构、合法存有本人信息的第三方以及</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">行内系统，收集、存储个人信息</span>
            <span style="font-family:宋体; font-size:11pt">及本人信贷信息、信用报告等</span>
            <span style="font-family:宋体; font-size:11pt">，并对其进行必要的使用、加工。</span>
            <span style="font-family:宋体; font-size:11pt">并同意授权，被授权人将上述个人信息、个人信贷信息和信用报告以及其他相关信息中的必要信息提供、传输至上述所列合法机构，该合法机构使用该信息向被授权人提供相关信息查询、下载等服务，将查询、核实结果提供、传输至被授权人，及履行法定职责或法定义务。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">3</span><span style="font-family:宋体; font-size:11pt">、</span>
            <span style="font-family:宋体; font-size:11pt">本人同意并授权百行征信有限公司基于开展征信业务目的，有权向被授权人和合法留存本人信息的机构（包括但不限于公安、司法、教育、全国公民身份证号码查询服务中心、通信运营商、银联、社保、公积金、税务、民政、物流、电子商务平台、互联网平台、行业协会等合法留存本人信息的第三方机构等）查询、核实、收集如下信息：本人的基本信息、借贷信息、其他相关信息。本人同意并授权百行征信有限公司有权对从合法留存本人信息的机构采集的本人信息进行存储、整理、保存、加工，并将采集的信息或信息处理结果提供给经本人授权的第三方使用。因本条产生的异议，包括需查询、复制、补充、提供、删除个人信息或撤回授权的，可通过以下联系方式联系百行征信有限公司。百行征信有限公司联系方式为：400-007-1100，邮箱bhcs@baihangcredit.com,登陆“百行征信”app或前往百行征信客服中心。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">4</span><span style="font-family:宋体; font-size:11pt">、</span>
            <span style="font-family:宋体; font-size:11pt">本人同意朴道征信有限公司（联系方式：service@pudaocredit.cn
              ）基于为本人与被授权人之间的金融活动提供信用服务，可向被授权人和有关部门、单位（包括但不限于公安、司法、教育、全国公民身份证号码查询服务中心、通信运营商、银联、通联、易宝、宝付、旷视、社保、公积金、税务、民政、物流、电子商务平台、互联网平台、行业协会等合法留存本人信息的第三方机构等）查询、核实、采集、整理、保存、加工本人能够用于判断个人信用状况的各类信息（包括但不限于个人的身份、地址、交通、通信、债务、财产、支付、消费、生产经营、履行法定义务等信息，以及基于前述信息对个人信用状况形成的分析、评价类信息），包括可能对本人产生负面影响的不良信息，并可将上述信息在本授权书所列的用途范围内向被授权人提供。上述信息的保存期限为法律法规要求的最短时间，其中个人不良信息的保存期限为自不良行为或事件终止之日起5年。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">5</span><span style="font-family:宋体; font-size:11pt">、本人同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">：被授权人</span>
            <span style="font-family:宋体; font-size:11pt">基于风险管理目的，在本人通过电脑、手机等电子设备使用</span>
            <span style="font-family:宋体; font-size:11pt">贷款</span>
            <span style="font-family:宋体; font-size:11pt">服务时，收集、存储该设备位置信息，并对其进行必要的使用、加工。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">6</span><span style="font-family:宋体; font-size:11pt">、本人同意并授权：</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">为了防范风险等合法目的，向合法留存本人信息的其他方（如被授权人的合作伙伴等，具体合作伙伴范围等以被授权人网站/APP或其他公开渠道公布的名单为准）收集或核验与授权业务相关的必要信息；如本人出现违约或可能危及</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span><span style="font-family:宋体; font-size:11pt">债权的情形时，</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">无法通过本人预留联系方式取得有效联系的，</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">有权向金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司、行政机关、司法机关、通信运营商、本人的单位和联系人及合法存有本人信息的第三方收集、存储其他有效联系方式，并对其进行必要的使用、加工。本人承诺：向</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">提供的第三方联系人信息，本人已充分告知第三方并取得其同意。因本人承诺不实或者第三方因本人提供其信息而向</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span><span style="font-family:宋体; font-size:11pt">索赔，给</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">造成损失或其他不利后果的，由本人承担赔偿责任。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">三</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">、本人同意并授权：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人可以向</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">中国人民银行金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司等</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">依法设立的征信机构或信用服务机构提供本人的个人基础信息（包括但不限于本人的基本信息、借贷信息、履约风险信息、担保信息、商业保险信息、不动产信息、纳税信息、设备信息、实名验证信息、人脸识别结果、收入信息、消费信息、车辆信息）和信贷业务交易等相关信用信息（包括但不限于本人因未及时履行合同义务产生的不良信息）。本人知悉，被授权人向征信机构提供本人相关信息为其履行《征信业管理条例》第二十九条（即“向金融信用信息基础数据库提供信贷信息”）规定的义务所必须。且本人知悉，信用记录、信用报告或信用评分是国家机关、其他个人和机构对信用进行依法查询和/或提供服务或进行限制的参考依据，本人已经理解并知悉提供该等信息可能会对本人产生的影响。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">四</span>
            <span style="font-family:宋体; font-size:11pt">、本人同意并授权：被授权人可收集、存储、使用、分析本人在注册、使用服务时，在被授权人的相关历史信息、支付数据信息和本人注册、使用被授权人软件产品产生的相关必要信息等，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">包括但不限于所提供的姓名，身份证信息、影像，银行卡信息、影像，身份验证过程中产生的图像视频数据等相关身份信息</span>
            <span style="font-family:宋体; font-size:11pt">以及使用本服务的相关操作及行为信息（例如，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">操作记录、设备型号和配置、操作系统版本、设备配置、唯一设备标识符等软硬件特征信息，IP地址、GPS位置和基站等传感器信息等位置信息，及浏览器的类型、电信运营商、使用的语言、访问日期和时间以及访问时长等对服务的详细使用情况，作为有关网络日志保存</span>
            <span style="font-family:宋体; font-size:11pt">）。本服务通过使用这些信息识别本人的身份，以便遵守国家相关法律法规的规定，为本人提供贷款服务。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">提示：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">上述信息涉及个人敏感信息，如</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">您</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">拒绝提供上述信息，被授权人将无法为</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">您</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">提供本服务，但不影响其为</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">您</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">提供其他服务。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">五</span>
            <span style="font-family:宋体; font-size:11pt">、本人知悉并同意在后续的信贷业务相关服务（如额度调整、还款方式变更、客户资料变更等）办理流程中补充及调整相关个人信息，如个人身份信息、联系方式、学历学籍信息、居住信息、职业信息、账户信息、交易信息等必要信息时，无需重新进行授权。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">六</span><span style="font-family:宋体; font-size:11pt">、本人同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">：（</span><span style="font-family:宋体; font-size:11pt">1</span>
            <span style="font-family:宋体; font-size:11pt">）</span><span style="font-family:宋体; font-size:11pt">如</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">将本授权书涉及的业务所对应的债权及担保权利转让给第三方时，为订立、履行本人作为一方当事人的合同所必需，</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">有权依法合规在必要范围内向潜在受让的金融机构提供本授权书涉及的业务的相关资料及本人信息，而无须另行征得本人同意。</span>
            <span style="font-family:宋体; font-size:11pt">（</span><span style="font-family:宋体; font-size:11pt">2</span>
            <span style="font-family:宋体; font-size:11pt">）</span>
            <span style="font-family:宋体; font-size:11pt">被授权人转让其所拥有的针对本人的债权时，依照法律法规的规定，向债权受让方提供个人基本信息、个人联系方式、账户信息等必要个人信息，用于业务处理的必要需求</span>
            <span style="font-family:宋体; font-size:11pt">，而无须另行征得本人同意</span><span style="font-family:宋体; font-size:11pt">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.85pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">七</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">、本人同意并授权：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">为了维护被授权人的合法权益，在本人逾期还款或者出现本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">违反</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">与被授权人签署的合同、协议、承诺或其他法律文件项下的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">约定</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">时，被授权人可将本人的联系方式、联系地址及本人违约信息等信息公开，并根据欠款催收、债权转让、金融外包等需要将</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">个人基本信息、个人联系方式、账户信息等必要个人信息</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">提供给被授权人委托的催收机构、资产管理公司、外包公司等第三方使用，本人知晓并同意具体第三方范围、联系方式、处理目的、处理方式和个人信息种类等以被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">准入的有资质的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">名单为准。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">八</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">、本人同意并授权：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">为便于向本人提供更加优质的服务和产品，本人授权被授权人可以将前述信息分享给与本人在被授权人办理业务相关的被授权人合作伙伴，本人知晓并同意具体合作伙伴范围、联系方式、处理目的、处理方式和个人信息种类等以被授权人认可的名单为准。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.85pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">九</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人同意并自愿授权：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">将收集的个人信息进行存储，保存期限为本授权书生效之日起至本人与</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">业务关系终结之日另加</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">【</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">5</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">】</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">年。如法律、行政法规、政府规章、监管规范（包括但不限于反洗钱）对客户个人信息资料有更长保存期限要求的，遵守其规定。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">超过存储期限，被授权人会将您的个人信息删除或匿名化处理。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.85pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">十</span><span style="font-family:宋体; font-size:11pt">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人声明：本授权书是本人向被授权人做出的单方承诺，且效力具有独立性，不因《借款额度合同》、《借款合同》</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">等</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">（以实际名称为准）的任何条款无效而失效。</span>
            <span style="font-family:宋体; font-size:11pt">本授权书有效期自本授权书出具之日起至本人或前述涉及到本人在被授权人信贷业务终结之日止。如下情形视为本人与被授权人的业务未终结：本人在被授权人处有信贷余额或有授信额度；本人提供担保的授信业务有信贷余额或有授信额度。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">十一</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">若本人信贷业务未获批准，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">则本授权书自动失效，授权自动终止，同时同意</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">删除本人个人信息资料，无须退回本人。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十二、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人同意，因本人个人信息为被授权人进行风险评估及贷后管理所必须，因此，若本人撤回对被授权人的上述授权，则被授权人保留其停止发放贷款并要求授权人提前还贷的权利。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十三、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人已知悉</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">公布的相关隐私保密条款,了解</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">会按照国家信息系统安全保护相关要求，进行安全管理，维护本人的个人信息安全，并知悉本人在个人信息处理活动中还可向</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">行使法律所赋予本人对个人信息的知情权、决定权、查阅权、复制权、更正及补充权、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">撤回权、删除请求权、拒绝权、保护权、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">解释</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">请求</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">权等。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如本人拟按照《个人信息保护法》的规定行使上述权限，或存在其他有关争议、投诉或问题，本人可致电</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold; text-decoration:underline">被授权人客户服务电话95396</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">咨询或处理；撤回授权后，不会影响被授权人基于本人同意已进行的信息处理效力；如涉及提供个人信息查询、处理服务的其他主体，本人可按照其他联系方式或有关信息联系相应主体处理。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如果被授权人超出本授权书范围进行数据报送和查询使用，则被授权人应承担与此有关的法律责任</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">符合《个人信息保护法》第十三条第2-7款等法律规定的情形除外。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">四</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本授权书修改，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">将提前公告或通知本人。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">有权根据实际业务情况选择以下一种或多种方式予以通知，具体可供选择的通知方式包括但不限于网站公告、电子邮件告知、短信通知、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">APP或者微信小程序/公众号公告、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">报刊公告或电话通知等。该等变更自公告或通知中载明的生效日期起开始生效，本人有权在生效日期前选择是否同意该等变更。如本人不接受该等变更，本人将在公告或通知中载明的生效日期前停止使用</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人提供的服务，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">否则视为本人同意该等变更，变更后的内容对本人具有法律约束力。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十五、上述个人信息原则上将存储于中华人民共和国境内（不包括香港、澳门特别行政区及台湾地区）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十六、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">若本人与以上被授权人发生任何纠纷或争议，首先应友好协商解决；协商不成的，本人同意将纠纷或争议提交本授权书签订地（即中国吉林省长春市南关区）有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十七、如被授权人申请电子认证，本人同意并授权被授权人根据《电子认证服务管理办法》通过系统对接，将本人的个人信息（姓名、证件类型、证件号码）提供给电子认证服务提供者，进行电子认证，以保证本授权的有效性及其内容不被篡改。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">本人声明：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">本人已年满【18】周岁。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">本人同意本授权书以数据电文形式成立，自本人在线确认起即生效。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人已经仔细阅读上述条款，并特别注意黑体字的内容，被授权人已应本人要求对相关条款予以明确说明。本人对所有条款的含义及相应的法律后果已全部通晓并充分理解，本人自愿作出上述授权、承诺和声明。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">授权人：【</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">】</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">身份证件号码：【&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&nbsp;&nbsp;&nbsp; </span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&nbsp;&nbsp;&nbsp; </span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&nbsp; 】</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">签署日期（授权书生效日期）：【</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">】</span>
          </p>
        </div>
        <br />
        <br />
        <br />
        <div>
          <p style="font-size:22pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-align:center; text-indent:10pt; widows:0">
            <span style="font-family:黑体; font-size:22pt">个人征信客户授权书</span>
          </p>
          <p style="line-height:22pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:14pt; font-weight:bold">&#xa0;</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">尊敬的客户：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">为了维护您的权益，请在签署本授权书前，仔细阅读本授权书各条款（特别是黑体字条款），关注您在授权书中的权利、义务。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">吉林亿联银行股份有限公司投诉咨询热线：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">95396</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; widows:0">
            <span style="font-family:宋体; font-size:11pt">吉林亿联银行股份有限公司（以下简称：被授权人）:</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">一、</span>
            <span style="font-family:宋体; font-size:11pt">本人同意</span>
            <span style="font-family:宋体; font-size:11pt">并</span>
            <span style="font-family:宋体; font-size:11pt">授权：被授权人按照</span>
            <span style="font-family:宋体; font-size:11pt">《征信业管理条例》等国家相关规定采集并</span>
            <span style="font-family:宋体; font-size:11pt">向中国人民银行金融信用信息基础数据库</span>
            <span style="font-family:宋体; font-size:11pt">、</span>
            <span style="font-family:宋体; font-size:11pt">百行征信有限公司、朴道征信有限公司</span>
            <span style="font-family:宋体; font-size:11pt">报送本人个人信息及信用信息（包括但不限于信贷信息及对信息主体信用状况构成负面影响的</span>
            <span style="font-family:宋体; font-size:11pt">不良</span>
            <span style="font-family:宋体; font-size:11pt">信息）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">二、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">本人同意</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">并</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">授权：被授权人可以</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">根据国家有关规定，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">在</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">办理涉及本人的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">信贷业务申请阶段及业务存续期间，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">向中国人民银行金融信用信息基础数据库</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">百行征信有限公司、朴道征信有限公司</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">查询、打印、保存本人的信用信息，并用于下述用途：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">√</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">审核本人授信及贷款申请；</span>
            <span style="width:18pt; text-indent:0pt; display:inline-block"></span>
            <span style="width:21pt; text-indent:0pt; display:inline-block"></span>
            <span style="width:21pt; text-indent:0pt; display:inline-block"></span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">□</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">审核本人作为</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">其他个人、法人、其他组织机构办理信贷业务的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">担保人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">或相关还款责任人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">包括事前审核和事后跟踪管理环节；</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">√</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">对已</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">发生的业务</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">进行贷后风险管理；</span>
            <span style="width:1pt; text-indent:0pt; display:inline-block"></span>
            <span style="width:21pt; text-indent:0pt; display:inline-block"></span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">√</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">处理本人异议申请</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">；</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">□受理法人、其他组织</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">机构</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">授信及</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">贷款申请</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">或其作为担保人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">或相关还款责任人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，需要</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">查询其法定代表人、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">负责人等</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">关联人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">信用状况</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">包括事前审核和事后跟踪管理；</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">本人知晓并同意被授权人有权向中国人民银行金融信用信息基础数据库核实本人资料、信息和记录，包括但不限于公积金、收入、社保、信用信息以及其他与本人有关的资料、信息和记录。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">3、</span>
            <span style="font-family:宋体; font-size:11pt">本人声明：本授权书是本人向贵行做出的单方承诺，且效力具有独立性，不因《借款额度合同》</span>
            <span style="font-family:宋体; font-size:11pt">等其他协议</span>
            <span style="font-family:宋体; font-size:11pt">条款</span>
            <span style="font-family:宋体; font-size:11pt">的</span>
            <span style="font-family:宋体; font-size:11pt">无效而失效。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">4、</span>
            <span style="font-family:宋体; font-size:11pt">本授权书有效期自本授权书出具之日起至本人或前述涉及到本人在被授权人信贷业务</span>
            <span style="font-family:宋体; font-size:11pt">终结</span>
            <span style="font-family:宋体; font-size:11pt">之日止。如下情形视为本人与被授权人的业务未终结：本人在被授权人处有信贷余额或有授信额度；本人提供担保的授信业务有信贷余额或有授信额度。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">五</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人同意，因本人个人信息为被授权人进行风险评估及贷后管理所必须，因此，若本人撤回对被授权人的上述授权，则被授权人保留其停止发放贷款并要求授权人提前还贷的权利。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">六</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">本人知晓并同意若本人出现不良还款行为，被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">可按照《征信业管理条例》要求，通过本人在业务办理过程中留存的联系信息，以短信、邮件、APPPUSH、语音等方式进行不良还款行为上报告知，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">若因本人留存信息错误、发生变更、服务运营商网络不稳定或故障等客观因素，导致告知信息未触达或未及时触达本人的，将视为被授权人已履行告知义务。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">七</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人已被明确告知不良还款信息一旦记录在中国人民银行金融信用信息基础数据库中，在日后的经济活动中对本人可能产生的不良影响。包括但不限于：将上述信息应用于对本人的信用评估或出具信用报告后，可能导致本人在申请某项业务时（如网络信贷），提供该等业务的机构因参考上述信用评估或信用报告而最终拒绝或终止向本人提供该等业务；以及虽采取了严格的符合国家认证标准的安全保护措施对所采集的上述信息实施了安全保护，但仍可能存在的因不可抗力或高科技本身所不可克服的漏洞或意外的恶意黑客攻击导致部分信息泄露的风险。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">八</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">若本人信贷业务未获批准，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">则本授权书自动失效，授权自动终止。同时，本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">同意被授权人自行删除本人个人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">征信</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">资料</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，无须退回本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">九</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt">如果被授权人超出本授权书范围进行数据报送和查询使用，则被授权人应承担与此有关的法律责任。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本授权书内容与相关业务的合同条款不一致的，无论相关合同在本授权书之前或之后签署，均应以本授权书的内容为准</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">但相关合同条款明确约定是针对本授权书内容所做修订的除外。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十一、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人知悉，被授权人所获取的本人征信信息保存期限为【</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">5</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">】年。若因本人逾期还款等情形，被授权人于上述期限后仍有使用本人信息之必要的，本人同意被授权人将本人的征信信息保存至上述情形消灭之日</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">起</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">【</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">5</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">】</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">年</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">二</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">若本人与以上被授权人发生任何纠纷或争议，首先应友好协商解决；协商不成的，本人同意将纠纷或争议提交本授权书签订地（即中国吉林省长春市南关区）有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人声明：本人已仔细阅读上述所有条款，并已特别注意字体加黑的内容，被授权人已应本人要求对相关条款予以明确说明。本人对所有条款的含义及相应的法律后果已全部通晓并充分理解，本人自愿作出上述授权、承诺和声明。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&#xa0;</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">授权人：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">身份证件号码：</span>
          </p>
          <p style="font-size:11pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">签署日期（授权书生效日期）：</span>
          </p>
        </div>
        <br />
        <br />
        <br />
        <div>
          <p style="margin:0pt 0pt 10pt; orphans:0; text-align:center; widows:0">
            <span style="font-family:仿宋_GB2312; font-size:22pt; font-weight:bold">敏感个人信息</span>
            <span style="font-family:仿宋_GB2312; font-size:22pt; font-weight:bold">处理</span>
            <span style="font-family:仿宋_GB2312; font-size:22pt; font-weight:bold">授权书</span>
          </p>
          <p style="margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:仿宋_GB2312; font-size:15pt">&#xa0;</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">特别提示：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">尊敬的客户：为了维护您的权益，请在签署本授权书前，仔细阅读本授权书各条款（特别关注字体加黑、加粗表述），关注您对本行的授权内容以及您的权利、义务和责任。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如您对亿联银行信贷业务个人信息处理活动有任何疑问、意见或建议，您可致电</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold; text-decoration:underline">客户服务电话</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold; text-decoration:underline">95396</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">进行咨询，或者通过贷款人和/或贷款人线上服务平台、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">线上客服</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">等进行咨询了解，查询、获知您行使个人信息主体相关权利的方式和程序。一旦您通过点击或其他方式确认本授权书，即意味着您已知晓、理解本授权书中的全部内容（包括对有关权利义务和/或责任限制、免除条款的法律含义有充分的理解），同意按照本授权书条款处理您的相关信息。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本授权书是由您出具的授权吉林亿联银行股份有限公司（以下简称“亿联银行”、“被授权人”）处理敏感个人信息的文件。基于您个人同意由亿联银行处理您的个人信息的，您有权撤回同意，但您需了解，在您撤回前已进行的信息收集、处理行为的效力不受影响；若撤回授权，将影响亿联银行为您提供贷款相关服务。您可通过拨打</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold; text-decoration:underline">亿联银行客户服务电话95396</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">咨询贷款相关授权并确认是否撤回同意。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt">深知</span>
            <span style="font-family:宋体; font-size:11pt">敏感</span>
            <span style="font-family:宋体; font-size:11pt">个人信息对您的重要性，会尽力维护您的</span>
            <span style="font-family:宋体; font-size:11pt">敏感</span>
            <span style="font-family:宋体; font-size:11pt">个人信息安全，遵循合法、正当、必要、诚信原则开展个人信息处理活动，依法公开处理信息的规则，明示处理信息的目的、方式和范围，并按照法律法规、监管要求及与您的相关约定处理您的个人信息，依法采取相应措施保护您的合法权益。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">请您理解，由于各种因素可能出现亿联银行无法合理预见、防范、避免、控制的意外情形，可能影响到您的个人信息安全，如发生个人信息安全事件，亿联银行将按照法律法规的要求，制定并组织实施个人信息安全事件应急预案，及时采取应急措施予以化解，同时将事件情况以合理有效的方式向您告知。亿联银行还将根据监管机构要求，上报个人信息安全事件及处置情况。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">吉林亿联银行股份有限公司：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:30pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">本人知悉敏感信息对个人权益的影响，并作为向亿联银行申请贷款服务的借款人，本人同意并授权如下：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">一、本人同意并授权亿联银行处理（包括但不限于收集、存储、使用、加工、传输、提供、公开、删除等）如下敏感个人信息：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">1、个人身份信息：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">包括证件种类及号码、有效期限、婚姻状况</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">居住地址信息。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">2、个人财产信息：银行账户信息、资产信息、房产信息、收入状况、信贷记录、征信信息、交易和消费记录、流水记录、税务信息、社保账户信息及公积金信息。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">3、个人生物识别信息：指纹、声纹、掌纹、虹膜、面部识别特征。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">4、个人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">联系方式</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">联系地址、联系电话、电子邮箱地址</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">5、个人其他信息：精准定位信息、设备识别码信息、设备地址信息、常用设备信息、浏览器环境信息、音视频双录信息（包含电核录音、视频连线、视频核验等）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">二</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人</span>
            <span style="font-family:宋体; font-size:11pt">同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">亿联银行基于提供贷款服务的需求，将敏感个人信息用于</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">贷款服务相关的身份识别、资质审查、风险评估、风险管理、贷前调查、审查审批、合同签署、放款审核、额度管理、风险监测、担保办理、客户服务、权益服务、贷后管理（含催收、逾期资产处置、诉讼仲裁）、贷后服务、资产转让、债权转让、客户服务（含投诉处理）、数据研究分析等用途，以及在被授权人监管机构要求的信用监控、授权人申请征信异议处理、依法或依有权部门要求的其他工作，或其他经本人同意的合法用途。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">1、本人</span>
            <span style="font-family:宋体; font-size:11pt">同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">：</span>
            <span style="font-family:宋体; font-size:11pt">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt">基于处理目的收集、存储、使用、加工</span>
            <span style="font-family:宋体; font-size:11pt">本人</span>
            <span style="font-family:宋体; font-size:11pt">在使用</span>
            <span style="font-family:宋体; font-size:11pt">信贷服务</span>
            <span style="font-family:宋体; font-size:11pt">过程中主动提供或因此产生的必要敏感个人信息</span>
            <span style="font-family:宋体; font-size:11pt">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">2、本人</span>
            <span style="font-family:宋体; font-size:11pt">同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">：</span>
            <span style="font-family:宋体; font-size:11pt">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt">基于处理目的向金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司、行政机关、司法机关、社会保障管理机构、住房公积金管理机构、通信运营商、银行卡清算机构、合法存有</span>
            <span style="font-family:宋体; font-size:11pt">本人</span>
            <span style="font-family:宋体; font-size:11pt">信息的第三方以及</span>
            <span style="font-family:宋体; font-size:11pt">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt">行内系统，收集、存储必要敏感个人信息，并对其进行必要的使用、加工。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">3、本人</span>
            <span style="font-family:宋体; font-size:11pt">同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">：亿联银行</span>
            <span style="font-family:宋体; font-size:11pt">基于风险管理目的，在</span>
            <span style="font-family:宋体; font-size:11pt">本人</span>
            <span style="font-family:宋体; font-size:11pt">通过电脑、手机等电子设备使用</span>
            <span style="font-family:宋体; font-size:11pt">贷款</span>
            <span style="font-family:宋体; font-size:11pt">服务时，收集、存储该设备位置信息，并对其进行必要的使用、加工。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">4、本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">同意并授权：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">出现违约或可能危及</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">债权的情形时，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">无法通过</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">预留联系方式取得有效联系的，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">有权向金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司、行政机关、司法机关、通信运营商、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">的单位和联系人及合法存有</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">信息的第三方收集、存储其他有效联系方式，并对其进行必要的使用、加工</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold; text-decoration:underline">。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold; text-decoration:underline">本人承诺：向亿联银行提供的第三方联系人信息，本人已充分告知第三方并取得其同意。因本人承诺不实或者第三方因本人提供其信息而向亿联银行索赔，给亿联银行造成损失或其他不利后果的，由本人承担赔偿责任。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">三、本人同意并授权如亿联银行将本授权书涉及的业务所对应的债权及担保权利转让给第三方时，为订立、履行本人作为一方当事人的合同所必需，亿联银行有权依法合规在必要范围内向潜在受让的金融机构提供本授权书涉及的业务的相关资料及本人信息，而无须另行征得本人同意。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">四、本人知悉并同意在后续的信贷业务相关服务（如额度调整、还款方式变更、客户资料变更等）办理流程中补充及调整相关个人信息，如个人身份信息、联系方式、学历学籍信息、居住信息、职业信息、账户信息、交易信息等必要信息时，无需重新进行授权。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">五、本人同意并自愿授权：亿联银行将收集的个人信息进行存储，保存期限为本授权书生效之日起至本人与亿联银行业务关系终结之日另加【5】年。如法律、行政法规、政府规章、监管规范（包括但不限于反洗钱）对客户个人信息资料有更长保存期限要求的，遵守其规定。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">六、风险提示：敏感个人信息等信息为重要且</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">私密的个人信息，一旦泄露或者非法使用，容易导致人格尊严受到侵害或者人身、财产安全受到危害。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">七、本人授权并同意，本授权书所称敏感个人信息的处理，本授权书未约定的，按照本人与亿联银行签订的《个人信息处理授权书》约定处理。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">八、若本人与以上被授权人发生任何纠纷或争议，首先应友好协商解决；协商不成的，本人同意将纠纷或争议提交本授权书签订地（即中国吉林省长春市南关区）有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">九、本授权书系本人对亿联银行的单方承诺，效力具有独立性，不因其他合同的任何条款无效而失效。本授权书有效期自本授权书出具之日起至本人或前述涉及到本人在被授权人信贷业务终结之日止。如下情形视为本人与被授权人的业务未终结：本人在被授权人处有信贷余额或有授信额度；本人提供担保的授信业务有信贷余额或有授信额度。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">本人声明：本人已年满【</span>
            <span style="font-family:宋体; font-size:11pt">系统填充</span>
            <span style="font-family:宋体; font-size:11pt">】周岁。本人同意本授权书以数据电文形式成立，自本人在线确认起即生效。本人已经仔细阅读上述条款，并特别注意黑体字的内容，被授权人已应本人要求对相关条款予以明确说明。本人对所有条款的含义及相应的法律后果已全部通晓并充分理解，本人自愿作出上述授权、承诺和声明。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:11pt">授权人：【</span>
            <span style="font-family:宋体; font-size:11pt">系统填充</span>
            <span style="font-family:宋体; font-size:11pt">】</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:11pt">身份证件号码：【 </span>
            <span style="font-family:宋体; font-size:11pt">系统填充 </span>
            <span style="font-family:宋体; font-size:11pt">】</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:11pt">签署日期（授权书生效日期）：【</span>
            <span style="font-family:宋体; font-size:11pt">系统填充</span>
            <span style="font-family:宋体; font-size:11pt">】</span>
          </p>
        </div>
        <br />
        <br />
        <br />
        <div>
          <div style="-aw-headerfooter-type:header-primary">
          </div>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-align:center; line-height:22pt; widows:0; orphans:0"
          >
            <span style=" font-size:21pt; font-weight:bold"
              >企业信息查询及使用授权书</span
            >
          </p>
          <p style="margin-top:0pt; margin-bottom:0pt; line-height:22pt; widows:0; orphans:0">
            <span style=" font-size:11pt; font-weight:bold">尊敬的客户：</span>
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:22pt; line-height:22pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >请确认您有权代表贵单位作出企业金融信息使用授权。如未经贵单位充分授权，您无权签
              署本授权书。为了保障贵单位的合法权益，在您确认签署本授权书之前，请您务必仔细阅读本授权书的所有条款，尤其加粗部分条款，并请您充分理解条款内容，如您对本授权书有任何异议或者疑问，请立即停止后续确认签署行为并及时与客服联系。如您不接受本授权书的任何条款，请您拒绝签署。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:22pt; line-height:22pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >吉林亿联银行股份有限公司投诉咨询热线：95396</span
            >
          </p>
          <p style="margin-top:0pt; margin-bottom:0pt; line-height:20pt; widows:0; orphans:0">
            <span style=" font-size:11pt"
              >吉林亿联银行股份有限公司（以下简称：被授权人）:</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:22pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">本企业充分理解并同意，鉴于授权人</span
            ><span style=" font-size:11pt; text-decoration:underline"
              >【 】【统一社会信用代码 ： 】</span
            ><span style=" font-size:11pt"
              >或涉及授权人的法定代表人/股东向被授权人申请贷款服务，为客观、准确地评估本企业的信用等级和授信额度，并为本企业提供优质的服务，就使用本企业的相关必要信息，本企业同意并授权如下：</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold">一、</span
            ><span style=" font-size:11pt">本企业同意并授权</span
            ><span style=" font-size:11pt; font-weight:bold">：</span
            ><span style=" font-size:11pt"
              >被授权人在办理以下涉及到本企业的业务时，为信用评估、风险控制、逾期账款催收等与《借款额度合同》、《借款合同》等（以实际名称为准）履行相关的目的，可以向中国人民银行金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司等依法设立的征信机构或信用服务机构查询、使用本人的信用信息和信用报告；收集在本人申请或使用授权业务过程中及还款期内，向被授权人提交的信息或新产生的信息；为了防范风险等合法目的，向合法留存本人信息的其他方（如被授权人的合作伙伴等，具体合作伙伴范围等以被授权人网站/APP或其他公开渠道公布的名单为准）收集或核验与授权业务相关的必要信息；向中国互联网金融协会、中国支付清算协会、公安部公民身份信息数据库、国际企业信用信息公示系统、法院公开信息平台、税务等部分政府机构、司法机关、公共事业单位、行业组织等第三方权威机构采集与授权业务相关的必要信息。上述信息采集方式包括但不限于查询、核实、采集、整理、打印、保存、加工和使用等符合法律法规规定的方式；上述本企业基本信息、信用信息和信用报告等包括但不限于名称、住所、经营范围、可证明依法设立或者可依法开展经营、社会活动的执照、证件或者文件的名称、号码和有效期限，行业、国籍、法定代表人或负责人和授权办理业务人员的姓名、身份证件或其他身份证明文件的种类、号码和有效期限，受益所有人的姓名、地址、身份证件或其他身份证明文件的种类、号码和有效期限，企业的联系地址、电子邮箱、工商信息、交易真实性、财务信息、税务信息、诉讼信息、执行信息、行政处罚信息和违法犯罪信息、互联网使用信息、互联网使用行为、银行账户真实性校验、设备信息、信用分析和信用评估结果、逾期及违约信息、授信及负债信息、对外担保信息、信贷交易记录、征信查询记录、失信被执行人信息、信用黑名单信息等企业信息、经营信息、征信信息、信用信息及各类不良信息。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">二、本企业同意并授权：</span
            ><span style=" font-size:11pt; font-weight:bold">被授权人可以向</span
            ><span style=" font-size:11pt"
              >中国人民银行金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司等</span
            ><span style=" font-size:11pt; font-weight:bold"
              >依法设立的征信机构或信用服务机构提供本企业的基础信息（包括但不限于本企业的基本信息、借贷信息、履约风险信息、担保信息）和信贷业务交易等相关信用信息（包括但不限于本企业因未及时履行合同义务产生的不良信息）。本企业知悉，被授权人向征信机构提供本企业相关信息为其履行《征信业管理条例》第二十九条（即</span
            ><span style=" font-size:11pt; font-weight:bold">“</span
            ><span style=" font-size:11pt; font-weight:bold"
              >向金融信用信息基础数据库提供信贷信息</span
            ><span style=" font-size:11pt; font-weight:bold">”</span
            ><span style=" font-size:11pt; font-weight:bold"
              >）规定的义务所必须。且本企业知悉，信用记录、信用报告或信用评分是国家机关、其他个人和机构对信用进行依法查询和/或提供服务或进行限制的参考依据，本企业已经理解并知悉提供该等信息可能会对本企业产生的影响。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt"
              >三、本企业同意并授权：被授权人可收集、存储、使用、分析本企业在注册、使用服务时，在被授权人的</span
            ><span style=" font-size:11pt; font-weight:bold"
              >相关历史信息、支付数据信息和本企业注册、使用被授权人软件产品产生的相关必要信息</span
            ><span style=" font-size:11pt">等，包括但不限于所提供</span
            ><span style=" font-size:11pt; font-weight:bold"
              >的名称，证照号码、注册地址、联系地址、电子邮箱、工商信息、交易真实性、财务信息、税务信息、诉讼信息、执行信息、行政处罚信息和违法犯罪信息、互联网使用信息、互联网使用行为、银行账户真实性校验、设备信息、信用分析和信用评估结果、逾期及违约信息、授信及负债信息、对外担保信息、信贷交易记录、征信查询记录、失信被执行人信息、信用黑名单信息等企业信息、经营信息、征信信息、信用信息及各类不良信息。</span
            ><span style=" font-size:11pt"
              >本服务通过使用这些信息识别本企业的身份，以便遵守国家相关法律法规的规定，为本企业提供贷款服务。上述信息属于涉及企业敏感信息，如本企业拒绝提供上述信息，被授权人将无法为本企业提供信贷服务，但不影响其为本企业提供其他服务。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt"
              >四、本企业同意被授权人可将获取的上述信息用于：</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >1.核验授权人身份真实性，对授权人资信状况进行风险评估与管理；</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >2.审核、审批、受理、办理授权人的贷款相关业务及授权人提供担保的贷款业务；</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >3.在该业务存续期间检测本企业的信用变化，进行贷后服务和管理；</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >4.涉及授权人法定代表人、经营者、关联人的信贷、担保或风险管理业务，需查询授权人信用信息及公司相关信息的；</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >5.授权人申请征信异议处理；</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >6.依法或经有权部门要求；</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >7.其他经过本企业同意的合法用途。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">五、本企业同意并授权：</span
            ><span style=" font-size:11pt; font-weight:bold"
              >为了维护被授权人的合法权益，在本企业逾期还款或者出现本企业与被授权人签署的合同、协议、承诺或其他法律文件项下的违约时，被授权人可将本企业的联系方式、联系地址及本企业违约信息等信息公开，并根据欠款催收、债权转让、金融外包等需要将有关信息提供给被授权人委托的催收机构、资产管理公司、外包公司等第三方使用，具体第三方范围、联系方式、处理目的、处理方式和个人信息种类等以被授权人网站/APP或其他公开渠道公布的名单为准</span
            ><span style=" font-size:11pt">。</span>
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">六、本企业同意并授权：</span
            ><span style=" font-size:11pt; font-weight:bold"
              >为便于向本企业提供更加优质的服务和产品，本企业授权被授权人可以将前述信息分享给与本企业在被授权人办理业务相关的被授权人合作伙伴，具体合作伙伴范围、联系方式、处理目的、处理方式和个人信息种类等以被授权人网站/APP或其他公开渠道公布的名单为准</span
            ><span style=" font-size:11pt">。</span>
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.85pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">七、本企业知悉，</span
            ><span style=" font-size:11pt; font-weight:bold"
              >被授权人所获取的本企业信息保存期限为【5】年。若因本企业逾期还款等情形，被授权人于上述期限后仍有使用本企业信息之必要的，本企业同意并授权被授权人将本企业的信息保存至上述情形消灭之日起【5】年。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">八、</span
            ><span style=" font-size:11pt; font-weight:bold"
              >本企业声明：本授权书是本企业向被授权人做出的单方承诺，且效力具有独立性，不因《借款额度合同》、《借款合同》等（以实际名称为准）的任何条款无效而失效。</span
            ><span style=" font-size:11pt; font-weight:bold"
              >本授权书有效期自本授权书出具之日起至本企业或前述涉及到本企业在被授权人信贷业务终结之日止。如下情形视为本企业与被授权人的业务未终结：本企业在被授权人处有信贷余额或有授信额度；本企业提供担保的授信业务有信贷余额或有授信额度。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">九、</span
            ><span style=" font-size:11pt; font-weight:bold"
              >若本企业信贷业务未获批准，</span
            ><span style=" font-size:11pt; font-weight:bold"
              >则本授权书自动失效，授权自动终止。同时，</span
            ><span style=" font-size:11pt; font-weight:bold"
              >本企业同意被授权人自行删除本企业个人信息资料，无须退回本企业。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >十、本企业同意，因本企业个人信息为被授权人进行风险评估及贷后管理所必须，因此，若本企业撤回对被授权人的上述授权，则被授权人保留其停止发放贷款并要求授权人提前还贷的权利。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >十一、如果被授权人超出本授权书范围进行数据报送和查询使用，则被授权人应承担与此有关的法律责任。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >十二、若本企业与以上被授权人发生任何纠纷或争议，首先应友好协商解决；协商不成的，本企业同意将纠纷或争议提交本授权书签订地（即中国吉林省长春市南关区）有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt"
              >本企业声明：本企业同意本授权书以数据电文形式成立，自本人在线确认起即生效。</span
            ><span style=" font-size:11pt; font-weight:bold"
              >本企业已经仔细阅读上述条款，并特别注意黑体字的内容，被授权人已应本企业要求对相关条款予以明确说明。本企业对所有条款的含义及相应的法律后果已全部通晓并充分理解，本企业自愿作出上述授权、承诺和声明。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold">授权企业：</span>
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold">法定代表人：</span>
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >签署日期（授权书生效日期）：</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color {
  width: 100%;
  height: 100%;
}
.crossBox {
  text-align: right;
}
.cross {
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.clause {
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  /* font-size: 12px; */
}
body {
  font-family: "微软雅黑";
}
.distance {
  text-align: left;

  /* margin-left: 14px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  /* text-indent: 6px; */
}
.distance_80 {
  text-align: left;

  /* margin-left: 14px; */
}
p {
  margin-bottom: 8px;
  text-align: left;
}
li,
h2 {
  text-align: left;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 14px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
